// @core/api/endpoints/billing/pay_invoice.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PayInvoiceRequest,
  PayInvoiceResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Pay invoice
 * Records a full or partial payment for an invoice. Creates a transaction using the specified or default payment method.
 */
export async function PayInvoice(
  id: string,
  data: PayInvoiceRequest,
  options?: RequestOptions
): Promise<PayInvoiceResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/invoices/:id/pay`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.post<PayInvoiceResponse>(requestPath, data, requestOptions);
}
